import React from 'react';
import { Route } from 'react-router-dom';

import { NoDogfoodingWarning } from '../../components/NoDogfoodingWarning';
import { TrackedRoutes } from '../../components/TrackedRoutes';

import { OrderList } from './components';

export const OrdersPage: React.FC = () => {
  return (
    <>
      <NoDogfoodingWarning subject="orders" />
      <TrackedRoutes>
        <Route index element={<OrderList />} />
      </TrackedRoutes>
    </>
  );
};
